/* eslint-disable @typescript-eslint/no-explicit-any */
import 'core-js/features/promise'
import 'core-js/features/symbol'
import 'core-js/features/object/assign'
import 'core-js/features/array/from'
import 'core-js/features/map'
import 'core-js/features/set'
import 'whatwg-fetch'
import '@methods/resizeObserver.polyfill'
// Polyfill Promise.withResolvers for older browsers required by PDF.js
// @ts-expect-error Promise.withResolvers not yet in TS lib types
if (!Promise.withResolvers) {
  // Polyfill Promise.withResolvers for older browsers required by PDF.js
  // @ts-expect-error Promise.withResolvers not yet in TS lib types
  Promise.withResolvers = function () {
    let resolve: any, reject: any
    const promise = new Promise((res, rej) => {
      resolve = res
      reject = rej
    })
    return { promise, resolve, reject }
  }
}
